import store from '../../../../store';
import backOffice from './back-office';
import client from './client';

export default [
	{
		path: '/app/portfolio',
		name: 'portfolio',
		redirect: {
			name: 'dashboard'
		},
		component: () =>
			store.getters.user.type === 'back-office'
				? import(
						'../../../../components/dashboard/back-office/PortfoliosComponent.vue'
				  )
				: import(
						'../../../../components/dashboard/client/PortfolioComponent.vue'
				  ),
		children: [
            ...backOffice,
             ...client
        ]
	}
];
